import { callFunction } from "./functions-client";

// Recruiter talent pipeline (LOS Phase 8). Reads applications across the caller's
// jobs and manages private candidate notes; stage moves reuse jobs/set-status.
export interface PipelineApplication {
  id: string;
  status: string;
  cover_note: string | null;
  created_at: string;
  job_id: string;
  job_title: string | null;
  applicant_profile_id: string;
  applicant_name: string | null;
  applicant_headline: string | null;
  note_count: number;
}

export interface ApplicationNote {
  id: string;
  body: string;
  created_at: string;
}

export const PIPELINE_STAGES = ["applied", "reviewing", "accepted", "rejected"] as const;

export const getPipeline = () =>
  callFunction<{ applications: PipelineApplication[] }>("jobs/pipeline", { method: "GET" });

export const moveApplication = (application_id: string, status: string) =>
  callFunction<{ ok: boolean; application: { id: string; status: string } }>("jobs/set-status", { body: { application_id, status } });

export const addApplicationNote = (application_id: string, body: string) =>
  callFunction<{ note: ApplicationNote }>("jobs/note-add", { body: { application_id, body } });

export const listApplicationNotes = (application_id: string) =>
  callFunction<{ notes: ApplicationNote[] }>(`jobs/notes?application_id=${encodeURIComponent(application_id)}`, { method: "GET" });
